import React from 'react';
import '../App.css';
import mobilityImage from '../assets/mobility1.jpeg';
import MobilitySwiper from '../components/MobilitySwiper';
import { FaCheck } from "react-icons/fa";
import Stripes from '../components/Stripes';
import bg1 from "../assets/bg1.jpg";
import yogahall from "../assets/boxing.jpg";
import VerticalSwiper1 from '../components/VerticalSwiper1';
import Footer from '../components/Footer';
import Signup from '../components/Signup';


const Mobility = () => {
  return (
    <div className="mobility-page">
      {/* Hero Section */}
      <div
        className="mobility-banner"
        style={{ backgroundImage: `url(${mobilityImage})` }}
      >
        {/* Dark overlay */}
        <div className="banner-overlay"></div>

        <h2>MOBILITY</h2>
      </div>

      {/* Content Section */}
      <div className="mobility-content">
        <h3>What Is Mobility Training?</h3>
        <p>
          Mobility training is the practice of improving joint range of motion, muscular flexibility, and control—so you move better, feel better, and are less prone to injury. It’s more than stretching: it’s about learning to control your available motion, protect your joints, and unlock stiffness that limits performance in calisthenics, strength training, daily life, or sport.
        </p>
        <p>
          If strength is the engine, mobility is the steering and suspension.
        </p>
      </div>
      <MobilitySwiper />

      <div className="reasons-section container mt-5">
        <h3 className="coach">
          Why I Include Mobility in My  <br />Coaching
        </h3>

        {/* TOP 3 ITEMS */}
        <div className="parent">
          <div className="reason-box">
            <div className="check">
              <FaCheck className="check-mark" />
            </div>
            <p className="calistehenic-h">
              Better movement quality
            </p>
            <p className="calistehenic-p">
              You’ll move more fluidly in push, pull, squat, and overhead positions.                    </p>
          </div>

          <div className="reason-box">
            <div className="check">
              <FaCheck className="check-mark" />
            </div>
            <p className="calistehenic-h">Injury prevention</p>
            <p className="calistehenic-p">
              When joints, tissues, and muscles have room to move, you reduce risk of strains, impingements, or overuse injuries.
            </p>
          </div>

          <div className="reason-box">
            <div className="check">
              <FaCheck className="check-mark" />
            </div>
            <p className="calistehenic-h">More strength potential</p>
            <p className="calistehenic-p">
              If your body is “locked up,” you can’t access full strength in many movements. Mobility frees you to perform better.
            </p>
          </div>
        </div>

        {/* BOTTOM 2 ITEMS */}
        <div className="calisthenics mt-4">
          <div className="reason-box">
            <div className="check-marks">
              <FaCheck className="check-mark" />
            </div>
            <p className="calistehenic-h">Recovery enhancement</p>
            <p className="calistehenic-p">
              Mobility work helps you recover faster by increasing blood flow, flushing metabolites, and lengthening tight tissues.
            </p>
          </div>

          <div className="reason-box">
            <div className="check-marks">
              <FaCheck className="check-mark" />
            </div>
            <p className="calistehenic-h">Longevity</p>
            <p className="calistehenic-p">
              As you age, good mobility gives you more resilience, more comfort, and a stronger body for life.
            </p>
          </div>
        </div>
      </div>

      <Stripes />

      {/* who */}
      <div className="mobility-section">

        {/* Background Image */}
        <img
          src={bg1}
          alt="Background"
          className="mobility-bg"
        />

       <div className="mobility-overlay"></div>

{/* SECTION 1 */}
<div className="mobility-content container">
  <h2 className="mobility-title">
    HOW MY MOBILITY <br /> COACHING WORKS
  </h2>

  <div className="mobility-item">
    <p className="mobility-point">Movement & posture assessment.</p>
    <p className="mobility-text">
      I’ll test your current mobility in key joints (ankles, hips, thoracic spine, shoulders)
      and movement patterns (squats, lunges, overhead reach).
    </p>
  </div>

  <div className="mobility-item">
    <p className="mobility-point">Personal mobility plan.</p>
    <p className="mobility-text">
      You’ll get a tailored sequence of mobility drills, soft-tissue work, and activation exercises.
    </p>
  </div>

  <div className="mobility-item">
    <p className="mobility-point">Integrated warm-ups & cooldowns.</p>
    <p className="mobility-text">
      Each session begins and ends with mobility work to prime and reset you.
    </p>
  </div>

  <div className="mobility-item">
    <p className="mobility-point">Progressive joint control.</p>
    <p className="mobility-text">
      Gain control in new ranges like deeper hip flexion, better thoracic extension,
      and improved overhead reach.
    </p>
  </div>

  <div className="mobility-item">
    <p className="mobility-point">Ongoing feedback & tweaks.</p>
    <p className="mobility-text">
      As your movement improves, your plan evolves with you.
    </p>
  </div>
</div>

{/* SECTION 2 */}
<div className="mobility-content container mt-5">
  <h2 className="mobility-title">WHO THIS IS FOR</h2>

  <div className="mobility-list">
    <p>You struggle with stiffness or tightness (hips, shoulders, spine)</p>
    <p>Movements feel restricted or painful (squats, overhead presses, lunges)</p>
    <p>You want to <span className="bold">support strength work</span> and reduce injury risk</p>
    <p>You want to <span className="bold">improve mobility and control</span></p>
    <p>You want to feel more <span className="bold">limber and capable</span></p>
    <p>You care about <span className="bold">long-term joint health</span></p>
  </div>
</div>
</div>

      <div className="coaching-section">
        <img src={yogahall} alt="Background" className="coaching-bg" />
        <div className="coaching-overlay"></div>


       <div className="coaching-swiper">
          <VerticalSwiper1 />
        </div>

      </div>
      <Signup />
      <Footer />

    </div>


  );
};
export default Mobility;